
import { Link } from 'react-router-dom';

export default function Footer() {
  const currentYear = new Date().getFullYear();

  const navLinks = [
    { path: '/', label: 'Home', isExternal: false },
    { path: '/about', label: 'About', isExternal: false },
    { path: 'https://showroom.inflowinventory.com/914f282d-f0e8-e611-80c3-000d3a60113d', label: 'Products', isExternal: true },
    { path: '/contact-us', label: 'Contact Us', isExternal: false }
  ];

  return (
    <footer className="bg-teal-700 text-white mt-auto">
      <div className="w-full px-6 py-12">
        <div className="max-w-6xl mx-auto grid md:grid-cols-3 gap-8">
          {/* Company Info */}
          <div>
            <h3 className="text-xl font-bold mb-4">Bromine Systems Inc.</h3>
            <p className="text-teal-100 text-sm leading-relaxed">
              Leading provider of bromine delivery systems and water treatment solutions for the marine industry.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-xl font-bold mb-4">Quick Links</h3>
            <ul className="space-y-2">
              {navLinks.map((link) => (
                <li key={link.path}>
                  {link.isExternal ? (
                    <a
                      href={link.path}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="text-teal-100 hover:text-white transition-colors duration-300 text-sm cursor-pointer"
                    >
                      {link.label}
                    </a>
                  ) : (
                    <Link
                      to={link.path}
                      className="text-teal-100 hover:text-white transition-colors duration-300 text-sm cursor-pointer"
                    >
                      {link.label}
                    </Link>
                  )}
                </li>
              ))}
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-xl font-bold mb-4">Contact</h3>
            <div className="space-y-2 text-teal-100 text-sm">
              <p className="flex items-center">
                <i className="ri-mail-line mr-2"></i>
                brominesystems@yahoo.com
              </p>
              <p className="flex items-center">
                <i className="ri-global-line mr-2"></i>
                www.brominesystemsinc.com
              </p>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="max-w-6xl mx-auto mt-8 pt-8 border-t border-teal-600">
          <div className="flex flex-col md:flex-row justify-between items-center text-sm text-teal-100">
            <p>&copy; {currentYear} Bromine Systems Inc. All rights reserved.</p>
            <p className="mt-2 md:mt-0">
              <a 
                href="https://readdy.ai/?ref=logo" 
                target="_blank" 
                rel="nofollow noopener noreferrer"
                className="hover:text-white transition-colors duration-300 cursor-pointer"
              >
                Website Builder
              </a>
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}
